export const criteria = {
  title: 'Criteria',
  subtitle: 'Define the possible future configurations.',
  add: 'Add criterion',
  createTitle: 'New criterion',
  editTitle: 'Edit criterion',
  createValueTitle: 'New value',
  editValueTitle: 'Edit value',
  hasDependency: 'Has dependency',
  dependencyTitle: 'Dependency',
  dependencyDescription: 'Dependency settings will be available here.',
  dependencyCriterion: 'Category (type)',
  dependencyValue: 'Value',
  addedDependencies: 'Added dependencies',
  newDependencyDescription:
    'Pick a criterion and its value to add a new dependency.',
  addDependency: 'Add',
  undoDependency: 'Undo',
  removeDependency: 'Remove dependency {name}',
  emptyDependencyTitle: 'No criteria available',
  emptyDependencyDescription:
    'Earlier criteria have no values left to depend on. Add values to them first.',
  name: 'Name',
  codeLabel: 'Code',
  root: 'Root criterion',
  addValue: 'Add value',
  emptyValueTitle: 'Empty value',
  emptyValuesTitle: 'No criteria values yet',
  emptyValuesDescription: 'Add criteria before defining their values.',
  emptyCriterionValuesTitle: 'No values yet',
  emptyCriterionValuesDescription:
    'Add a value to make this criterion selectable.',
  emptyTitle: 'No criteria yet',
  emptyDescription: 'Add a criterion to define possible future configurations.',
  placeholderTitle: 'Empty criterion',
  placeholderDescription: 'Criterion details will be configured here.',
  dragHandle: 'Reorder criterion {number}',
  dragAloneGroupHint: 'Grab it with {key} held to move only this criterion',
  dragAloneHint:
    'Hold {key} to move only this criterion and the ones glued below it',
  dragCarriedByDependency: 'Moves along with the dragged criterion',
  dragHeldByDependency: 'Stays, it depends on a criterion it would pass',
  dragTopLocked:
    'The top criterion is in a group with the dragged one and cannot be replaced',
  required: 'Required',
  active: 'Active',
  code: 'No code',
  createdSuccess: 'Criterion created',
  updatedSuccess: 'Criterion updated',
  updatedIndexSuccess: 'Criteria order updated',
  valueCreatedSuccess: 'Value created',
  valueUpdatedSuccess: 'Value updated',
  valueUpdatedIndexSuccess: 'Values order updated',
  deletedSuccess: 'Criterion deleted',
  valueDeletedSuccess: 'Value deleted',
  deleteTitle: 'Delete criterion "{name}"?',
  deleteDescription:
    'Its values will be deleted too. Draft flows keep them, marked as deleted.',
  deleteValueTitle: 'Delete value "{name}"?',
  deleteValueDescription: 'Draft flows keep it, marked as deleted.',
  deleteArchivesFlows:
    'Published flows using it: {count}. They will be archived.',
  tabs: {
    criteria: 'Criteria',
    criteriaDescription:
      'Define the criteria that determine available configurations.',
    values: 'Criteria values',
    valuesDescription: 'Manage the available values for each criterion.',
  },
} as const
